function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { breakpointsAliases } from '@shopify/polaris-tokens';
import { isObject } from './is-object.js';
function classNames() {
  for (var _len = arguments.length, classes = new Array(_len), _key = 0; _key < _len; _key++) {
    classes[_key] = arguments[_key];
  }
  return classes.filter(Boolean).join(' ');
}
function variationName(name, value) {
  return "".concat(name).concat(value.charAt(0).toUpperCase()).concat(value.slice(1));
}
function sanitizeCustomProperties(styles) {
  var nonNullValues = Object.entries(styles).filter(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      _ = _ref2[0],
      value = _ref2[1];
    return value != null;
  });
  return nonNullValues.length ? Object.fromEntries(nonNullValues) : undefined;
}

/**
 * Given params like so:
 * (
 *   'button',
 *   'padding',
 *   'spacing',
 *   {
 *     sm: "4",
 *     lg: "6"
 *   }
 * )
 * Converts it to an object like so:
 * {
 *   '--pc-button-padding-sm': 'var(--p-spacing-4)',
 *   '--pc-button-padding-lg': 'var(--p-spacing-6)'
 * }
 *
 */
function getResponsiveProps(componentName, componentProp, tokenSubgroup, responsiveProp) {
  if (!responsiveProp) return {};
  var result;
  if (!isObject(responsiveProp)) {
    result = _defineProperty({}, breakpointsAliases[0], "var(--p-".concat(tokenSubgroup, "-").concat(responsiveProp, ")"));
  } else {
    result = Object.fromEntries(Object.entries(responsiveProp).map(function (_ref3) {
      var _ref4 = _slicedToArray(_ref3, 2),
        breakpointAlias = _ref4[0],
        aliasOrScale = _ref4[1];
      return [breakpointAlias, "var(--p-".concat(tokenSubgroup, "-").concat(aliasOrScale, ")")];
    }));
  }

  // Prefix each responsive key with the correct token name
  return Object.fromEntries(Object.entries(result).map(function (_ref5) {
    var _ref6 = _slicedToArray(_ref5, 2),
      breakpointAlias = _ref6[0],
      value = _ref6[1];
    return ["--pc-".concat(componentName, "-").concat(componentProp, "-").concat(breakpointAlias), value];
  }));
}
function getResponsiveValue(componentName, componentProp, responsiveProp) {
  if (!responsiveProp) return {};
  if (!isObject(responsiveProp)) {
    return _defineProperty({}, "--pc-".concat(componentName, "-").concat(componentProp, "-").concat(breakpointsAliases[0]), responsiveProp);
  }
  return Object.fromEntries(Object.entries(responsiveProp).map(function (_ref8) {
    var _ref9 = _slicedToArray(_ref8, 2),
      breakpointAlias = _ref9[0],
      responsiveValue = _ref9[1];
    return ["--pc-".concat(componentName, "-").concat(componentProp, "-").concat(breakpointAlias), responsiveValue];
  }));
}
export { classNames, getResponsiveProps, getResponsiveValue, sanitizeCustomProperties, variationName };